import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';

const CardPlaceholder = styled(Horizontal)`
  aspect-ratio: var(--card-aspect-ratio);
  background-color: var(--c-neutral-300);
  border-radius: var(--half-unit);
`;

type Props = {
  className?: string;
};

export const Placeholder = ({ className }: Props) => {
  return (
    <CardPlaceholder center className={className}>
      <FontAwesomeIcon icon={faUserPlus} />
    </CardPlaceholder>
  );
};
